export default __webpack_public_path__ + "static/img_welfare_8@2x-d66036071c2cf43847e1b74e3d82c79f.jpg";